
import {map} from 'rxjs/operators';
import { QATicketNotification, NotificationDeliveryStatus, NotificationEmailList } from './qaticketnotification.model';
import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Http } from '@angular/http';

/**
 * @description
 * @class
 */
@Injectable()
export class NotificationsService {

  private notificationurl = 'api/NotificationEmail/getactivenotifications';

  constructor(
    public httpclient: HttpClient,
    public _http: Http) {
  }

  getActiveQATicketNotifications(): Observable<QATicketNotification[]> {
    return this._http.get(this.notificationurl).pipe(map(res =>
      res.json()));
  }

  saveNotification(Status: string, QATicketId: number, SendToEmail: string, QARoal: string) {
    return new Promise(resolve => {
      this.httpclient.post('api/NotificationEmail/saveorcreatenotification',
        {
          Status: Status, QATicketId: QATicketId, SendToEmailList: SendToEmail, QARole: QARoal
        })
        .subscribe(data => {
          resolve(data);
        });
      setTimeout(() => resolve('An error occured.'), 100000);
    });
  }

  getAllNotificationsForToday(): Observable<QATicketNotification[]> {
    return this._http.get('api/NotificationEmail/getallnotificationsbydate').pipe(map(res =>
      res.json()));
  }

  getAllNotificationsByDate(startDate: string, endDate: string): Observable<QATicketNotification[]> {
    return this._http.get('api/NotificationEmail/getallnotificationsbydate', {
      params: { startDate: startDate, endDate: endDate }
    }).pipe(map(res =>
      res.json()));
  }
  getNotificationDeliveryStatusForToday(): Observable<NotificationDeliveryStatus[]> {
    return this._http.get('api/NotificationEmail/getnotificationdeliverystatus').pipe(map(res =>
      res.json()));
  }

  getNotificationDeliveryStatusByDate(startDate: string, endDate: string): Observable<NotificationDeliveryStatus[]> {
    return this._http.get('api/NotificationEmail/getnotificationdeliverystatus', {
      params: { startDate: startDate, endDate: endDate }
    }).pipe(map(res =>
      res.json()));
  }
  getEmailList(): Observable<NotificationEmailList[]> {
    return this.httpclient.get<NotificationEmailList[]>('api/NotificationEmail/getemaillist');
  }

  createEmail(email: NotificationEmailList) {
    return new Promise(resolve => {
      this.httpclient.post('api/NotificationEmail/saveemail',
        {
          EmailAddress: email.EmailAddress, Name : email.Name,
          QueueCategory: email.QueueCategory, Creation: email.Creation, CriticalLevel: email.CriticalLevel
        })
        .subscribe(data => {
          resolve(data);
        });
      setTimeout(() => resolve('An error occured.'), 100000);
    });
  }

  deleteEmail(id: number) {
    return this.httpclient.delete(`api/NotificationEmail/deleteemail?id=${id}`);
}
}
